<template>
  <div class="contact">
    <label class="label text -t3 -upper -semibold">{{ label }}</label>
    <a class="link text -t2" :href="type + ':' + typeString">{{
      typeString
    }}</a>
  </div>
</template>

<script>
export default {
  props: {
    type: String,
    label: String,
    telephone: String,
    email: String,
  },
  computed: {
    typeString() {
      return this.type == "tel" ? this.telephone : this.email;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "foundation-sites/scss/foundation.scss";
@import "@/assets/scss/_settings";
.contact {
  margin: vw-relative(25 0);
  &.-white {
    color: #fff;
  }
}
.label {
  display: block;
  margin-bottom: 0.2em;
  .-white & {
    color: #fff;
  }
}
.link {
  display: inline-block;
  .-white & {
    color: #fff;
  }
}
</style>
